import type { KpiCardSpec } from './card-spec';

/**
 * The Account deletions scalar, shown on the Users page's Retention pulse
 * section and the Retention & Health page's Retention breakdown. One object
 * in two catalogs, so the two pages cannot report different figures for the same KPI.
 */
export const ACCOUNT_DELETIONS_SCALAR_CARD: KpiCardSpec = {
    title: 'Account deletions',
    source: 'churn',
    metric: 'accountDeletions',
    form: 'number',
    size: 'sm',
    description:
        'Accounts permanently closed in the selected period, counted on the deletion date whenever the account was created. Same-day re-creations are included here and netted out of the churn rate instead.',
};
